// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"7896f6cb","391":"bf63027b","453":"97957904","551":"1fff5604","995":"25578f68"}[chunkId] + ".chunk.js";
};